import React from "react"
import { useColorModeValue, useColors } from "@mallardbay/lib-react-components"

import { usePageLayout } from "~contexts/page-layout-provider"
import type { NavigationMenuItemFieldsFragment } from "~graphql/dashboard.generated"
import { getFeatureIcon } from "~utils/feature-icons"
import SidebarRow from "~components/shared/sidebar/sidebar-row"

interface Props {
    readonly menuItem: NavigationMenuItemFieldsFragment
    readonly isSidebarCollapsed: boolean
}
export default function SidebarItem({ menuItem, isSidebarCollapsed }: Props) {
    const colors = useColors()
    const bgColor = useColorModeValue(colors.gray[100], colors.gray[800])
    const { closeSidebarIfMobile } = usePageLayout()
    const isFeatureBlocked = menuItem.is_paywalled || Boolean(menuItem.gate)

    const handleClick = () => {
        closeSidebarIfMobile()
    }

    return (
        <SidebarRow
            label={menuItem.label}
            link={getMenuItemLink(menuItem)}
            icon={getFeatureIcon(menuItem.icon_feature_key)}
            isSidebarCollapsed={isSidebarCollapsed}
            isFeatureBlocked={isFeatureBlocked}
            bgColor={bgColor}
            onClick={handleClick}
            isExternalLink={menuItem.is_external_link}
            featureStatus={menuItem.feature_status}
        />
    )
}

function getMenuItemLink(menuItem: NavigationMenuItemFieldsFragment) {
    if (menuItem.is_external_link) return menuItem.url

    return menuItem.route ?? menuItem.url
}
